//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import vComponent from '@/core/vComponent'
import { Sidebar, AppMain, Navbar } from '@/views/layout/components'
export default {
  name: 'Layout',
  extends: vComponent,
  components: { AppMain, Sidebar, Navbar },
  data () {
    return {
      leftDrawerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },
  mounted () {
    this.addHandler()
  },
  methods: {
    addHandler () {
      this.on('LeftDrawerOpen.Changed', (val) => {
        this.leftDrawerOpen = val
      })
    }
  }
}
